import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Session } from 'utils';

type ReturnType = Promise<AxiosResponse<Session>>;

export interface SessionDuplicationPayload {
    organization?: string | null;
}

const duplicateSession = (id: string, payload: SessionDuplicationPayload): ReturnType => {
    return Request.post(`/workouts/sessions/${id}/duplicate`, payload);
};

export default duplicateSession;
